import { Button, Card, Grid } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { useAppContext } from "../../../libs/app-core/AppContext";
import { MessageDialog } from "../../../libs/app-core/dialogs/MessageDialog";
import CheckBox from "../../../libs/rhf-mui/ui/CheckBox";
import { SpwkUtil } from "../../dao/SpwkUtil";
import { UniAnswer } from "../../dao/UniAnswer";
import { UniForm } from "../../dao/UniForm";
import { useGV } from "../../GV";
import AuthHelper from "../../heplers/AuthHelper";
import UcHeader from "./components/UcHeader";

type Props = {
  _UniAnswer: UniAnswer | null | undefined;
  _UniFormList: UniForm[] | undefined;

  IsV3Split: boolean;
  set_IsV3Split: React.Dispatch<React.SetStateAction<boolean>>;

  IsRemoveEmptyQuestion: boolean;
  set_IsRemoveEmptyQuestion: React.Dispatch<React.SetStateAction<boolean>>;

  IsAdjustOptions: boolean;
  set_IsAdjustOptions: React.Dispatch<React.SetStateAction<boolean>>;

  IsSkipValid: boolean;
  set_IsSkipValid: React.Dispatch<React.SetStateAction<boolean>>;

  IsSkipSave: boolean;
  set_IsSkipSave: React.Dispatch<React.SetStateAction<boolean>>;

  OnSkipValidChanged: (check: boolean) => void;
  IsJudgeGender : boolean;
  set_IsJudgeGender: React.Dispatch<React.SetStateAction<boolean>>;

};

const UcDevTools = ({
  _UniAnswer,
  _UniFormList,
  IsV3Split, set_IsV3Split,
  IsRemoveEmptyQuestion, set_IsRemoveEmptyQuestion,
  IsAdjustOptions, set_IsAdjustOptions,

  IsSkipValid, set_IsSkipValid,
  IsSkipSave, set_IsSkipSave,
  IsJudgeGender, set_IsJudgeGender,
  OnSkipValidChanged,

  ...props }: Props) => {

  let ctx = useAppContext();
  let GV = useGV();

  let rhf = useFormContext();

  return (
    <Card sx={{ p: 4 }}>
      <Grid container>
        <Grid item container px={2}>
          <div style={{color:'#DD6666'}}>answer: {_UniAnswer?.guid}</div>&nbsp;&nbsp;&nbsp;<div>member: {_UniAnswer?.member_guid}</div>
        </Grid>
        <Grid item container px={2}>
          {_UniFormList
            ?.map((uni_form) => {
              return uni_form.func_code + " " + uni_form.func_title;
            })
            .join(",  ")}
        </Grid>

        <Grid item container>
          <Grid item>
            <UcHeader />
          </Grid>

          <Grid item pt={2} mx={1}>
            <Button variant="contained" onClick={btn_AdminLogout_Click}>
              登出
            </Button>
          </Grid>

          <Grid item pt={2} mx={1}>
            <Button variant="contained" onClick={btn_JSON_Click}>
              JSON
            </Button>
          </Grid>

          <Grid item pt={2} mx={1}>
            <CheckBox label={"拆分"}
              markProps={{
                checked: IsV3Split,
                onChange(event, checked) {
                  set_IsV3Split(checked);
                },
              }}
            />
            <CheckBox label={"隱藏空題"}
              markProps={{
                checked: IsRemoveEmptyQuestion,
                onChange(event, checked) {
                  set_IsRemoveEmptyQuestion(checked);
                },
              }}
            />
            <CheckBox label={"調整選項"}
              markProps={{
                checked: IsAdjustOptions,
                onChange(event, checked) {
                  set_IsAdjustOptions(checked);
                },
              }}
            />
            <CheckBox label={"隱藏男女"}
              markProps={{
                checked: IsJudgeGender,
                onChange(event, checked) {
                  set_IsJudgeGender(checked);
                },
              }}
            />

            <CheckBox label={"不驗證"}
              markProps={{
                color: 'error',
                checked: IsSkipValid,
                onChange(event, checked) {
                  set_IsSkipValid(checked);
                  OnSkipValidChanged(checked);
                },
              }}
            />

            <CheckBox label={"不存檔"}
              markProps={{
                color: 'error',
                checked: IsSkipSave,
                onChange(event, checked) {
                  set_IsSkipSave(checked);
                },
              }}
            />


          </Grid>


        </Grid>
      </Grid>
    </Card>
  );

  function btn_AdminLogout_Click() {
    AuthHelper.Logout(GV, ctx);
  }

  function btn_JSON_Click() {
    let data = rhf.getValues();

    data = SpwkUtil.僅保留有Data中有輸入的數值(data);
    MessageDialog.Show(ctx, JSON.stringify(data, null, 4), "JSON", {
      colorMeaning: "Success",
    });
  }
};

export default UcDevTools;


